import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Provider } from '@app/models';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class ProviderService {
  constructor(private http: HttpClient) {}

  getManagement(followGroupsIds, page?) {
    return this.http.get<any>(`${API}providers/management?followGroupId=${followGroupsIds}&page=${page}`);
  }

  getManagementPage(followGroupsIds, page?: number) {
    const query = `followGroupId=${followGroupsIds}&page=${page || 0}`;

    return this.http.get<any>(`${API}providers/management?${query}`, {
      observe: 'response'
    });
  }

  deleteManagement(data){
    return this.http.delete<any>(`${API}providers/management/${data}`);
  }

  createManagement(data) {
    return this.http.post<any>(`${API}providers/management`, data);
  }

  updateManagement(id, data) {
    return this.http.put<any>(`${API}providers/management/${id}`, data);
  }

  updateProviderManagement(id, data) {
    return this.http.put<any>(`${API}providers/providerManagement/${id}`, data);
  }

  createProviderManagement(data){
    return this.http.post<any>(`${API}providers/providerManagement`, data);
  }

  addUserProvider(data){
    return this.http.post<any>(`${API}providers/userProviders`, data);
  }

  deleteUserProvider(id, data) {
    return this.http.put<any>(`${API}providers/userProviders/${id}`, data);
  }

  syncMdm(){
    return this.http.get<any>(`${API}providers/syncMdm`);
  }

  getSupplier(followGroupId?){
    if(followGroupId){
      return this.http.get<any>(`${API}providers/supplier?followGroupId=${followGroupId}`);
    }
    return this.http.get<any>(`${API}providers/supplier`);
  }

  getSupplierCounter(id){
    return this.http.get<any>(`${API}providers/supplier/${id}/count`);
  }

  get(page?: number, filterValue?: any, viewMode?: string) {
    // const query = `page=${page || 0}`;
    // const data = [{page: page, filterValue: filterValue}]
    // const data = [{page: `${page || 0}`, filterValue: filterValue}]

    // return this.http.get<Provider[]>(`${API}providers`);
    if (filterValue >= 0 || page >= 0) {
      return this.http.get<any>(
        `${API}providers?page=${page}&filter=${filterValue}&mode=${viewMode}`
      );
    } else {
      return this.http.get<any>(`${API}providers`);
    }
  }

  getById(ProviderId: number) {
    return this.http.get<Provider>(`${API}providers/${ProviderId}`);
  }

  getByFollowGroup(id, gerencyMode?) {
    return this.http.get<Provider[]>(`${API}providers?FollowGroupId=${id}&mode=${gerencyMode}`);
  }

  getProvidersRebate(followId) {
    return this.http.get(`${API}providers/rebate?FollowId=${followId}`)
  }

  createRebates(followId, data) {
    return this.http.post(`${API}providers/rebate?FollowId=${followId}`, data)
  }

  create(provider: Provider) {
    return this.http.post<Provider>(`${API}providers`, provider);
  }

  update(id, provider) {
    return this.http.put<Provider>(`${API}providers/${id}`, provider);
  }

  getProviders(page?: number) {
    const query = `page=${page || 0}`;

    return this.http.get<any>(`${API}providers?${query}`, {
      observe: 'response'
    });
  }

  search(conditions, FollowId) {
    const data = { filter: conditions, key: 'FollowId', value: FollowId };

    return this.http.post<any>(`${API}providers/providerSearch`, data);
  }

  searchPro(conditions, FollowId) {
    const data = [...conditions, { key: 'FollowId', value: FollowId }];

    return this.http.post<any>(`${API}providers/providerSearchProforma`, data);
  }

  delete(id) {
    return this.http.delete<any>(`${API}providers/${id}`);
  }
}
